import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import YoutubeEmbed from '../elements/YoutubeEmbed';

const HelpContent = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

  const sectionHeader = {
    title: 'Keep Me Out — Help Center',
    paragraph: ''
  };

  const IssueRestartIDs = {
    Realme: 'a7JIHTYZmq4',
    XIAOMI: 'test'
  };

  const IssueUninstallIDs = {
    Samsung: 'V41SmJuoedc',
    XIAOMI: 'test'
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className='center-content' />
          <h4 className='mt-0 mb-16'>Fix A Problem</h4>
          <Accordion style={{ marginBottom: 60 }}>
            <AccordionItem uuid='a'>
              <AccordionItemHeading>
                <AccordionItemButton id='IssueRestart'>
                  Lock Breaking After Restart
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {/* WIP */}
                <h5 className='mt-0 mb-16'>Video Guide</h5>
                {/* <ButtonGroup style={{ marginBottom: 10 }}>
                  <Button tag='a' color='primary' href='#'>
                    Samsung
                  </Button>
                  <Button tag='a' color='dark' href='#'>
                    XIAOMI
                  </Button>
                </ButtonGroup> */}
                <YoutubeEmbed embedId={IssueRestartIDs.Realme} />
                <p>
                  We recommend following our device specific video guide above.
                </p>
                <ol style={{ color: 'white' }}>
                  <li>
                    Enter the app information by long pressing the Keep Me Out
                    app icon and tapping on the “App info” button.
                  </li>
                  <li>
                    Select “Battery Usage” from the following info screen.
                  </li>
                  <li>
                    Enable “Allow auto-launch” from the privacy permissions.
                  </li>
                  <li>
                    Remember you need to also enable the option “Keep Locked
                    After Device Reboot / Restart” from the in-app settings
                    screen.
                  </li>
                </ol>
              </AccordionItemPanel>
            </AccordionItem>
            {/* WIP */}
            <AccordionItem uuid='b' id='IssueUninstall'>
              <AccordionItemHeading>
                <AccordionItemButton>
                  How to Uninstall the App
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {/* WIP */}
                <h5 className='mt-0 mb-16'>Video Guide</h5>
                {/* <ButtonGroup style={{ marginBottom: 10 }}>
                  <Button tag='a' color='primary' href='#'>
                    Samsung
                  </Button>
                  <Button tag='a' color='dark' href='#'>
                    XIAOMI
                  </Button>
                </ButtonGroup> */}
                <YoutubeEmbed embedId={IssueUninstallIDs.Samsung} />
                <p>
                  We recommend following our device specific video guide above.
                </p>
                <ol style={{ color: 'white' }}>
                  <li>
                    Open the Keep Me Out Settings screen from the icon in the
                    top right.
                  </li>
                  <li>Disable the option “Device Administrator”.</li>
                  <li>Uninstall the app from your phone's home screen.</li>
                </ol>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <h4 className='mt-0 mb-16' style={{ marginBottom: 20 }}>
            FAQ
          </h4>
          <h5 className='mt-0 mb-16'>
            I have encountered a bug / problem with your app, where can I report
            it?
          </h5>
          <p className='text-sm mb-32'>
            Please write a short description of your problem to{' '}
            <a href='mailto:keepmeoutapp@gmail.com'>
              keepmeoutapp@gmail.com
            </a>
            . Please be aware that due to the amount of mail we get, a reply may
            take some time.
          </p>
          <h5 className='mt-0 mb-16'>
            Does Keep Me Out store or read my personal data?
          </h5>
          <p className='text-sm mb-32'>
            At Keep Me Out we value your privacy and don’t believe in storing or
            selling personal or sensitive user data, as a principle.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I still receive calls when my phone is in “lock mode”?
          </h5>
          <p className='text-sm mb-32'>
            Yes, since the issue of an emergency could arise outside of your
            influence, we feel this is important. If you want to block contacts
            from calling you, we advise you to use your phone's privacy settings
            instead.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I call people while my phone is in lock mode?
          </h5>
          <p className='text-sm mb-32'>
            You can enable “emergency calling” in the app settings. That way you
            can add contacts to your emergency contact list, so you can easily
            reach them during lock times.
          </p>
          <h5 className='mt-0 mb-16'>How can I add emergency contacts?</h5>
          <p className='text-sm mb-32'>
            Open Settings on your device. Search for “Emergency Contacts”. Add
            contacts from your contact list.
          </p>
          <h5 className='mt-0 mb-16'>
            Can I disable the lock for specific apps?
          </h5>
          <p className='text-sm mb-32'>
            We are currently developing a feature that lets users exempt apps
            from lock mode. Stay tuned for updates!
          </p>
          <h5 className='mt-0 mb-16'>
            I have a feature idea / suggestion for your app, where can I share
            it?
          </h5>
          <p className='text-sm mb-32'>
            We welcome you to contact us at{' '}
            <a href='mailto:keepmeoutapp@gmail.com'>
              keepmeoutapp@gmail.com
            </a>
            . Please be aware that due to the amount of mail we get, a reply is
            not guaranteed and may take some time.
          </p>
          <h5 className='mt-0 mb-16'>
            Why is the scheduled lock not triggering on my KMO app when the device is not in use?
          </h5>
          <p className='text-sm mb-32'>
          The scheduled lock feature in the KMO app might not be triggering as expected when your device is not in use due to Android’s Doze mode and App Standby restrictions. Doze mode is a power-saving feature that restricts certain activities when the device is idle. According to Android’s documentation (https://developer.android.com/training/monitoring-device-state/doze-standby), in Doze mode, the system prevents CPU-intensive tasks, and this includes scheduled lock activities.
          </p>
          <h5 className='mt-0 mb-16'>
          What happens during Doze mode that affects the scheduled lock feature?
          </h5>
          <p className='text-sm mb-32'>
          During Doze mode, the device limits access to resources to conserve battery life. As a result, scheduled tasks, such as the lock feature in the KMO app, may not be triggered until the user interacts with the device by moving, unlocking, or glancing at the lock screen.
          </p>
          <h5 className='mt-0 mb-16'>
          How can I ensure that the scheduled lock works even when the device is in Doze mode?
          </h5>
          <p className='text-sm mb-32'>
          If you find that the scheduled lock is not activating as expected, try unlocking or looking at the lock screen. This interaction with the device will prompt the system to exit Doze mode, allowing the scheduled lock feature in the KMO app to be activated and function as intended for the remaining scheduled time.
          </p>
          <h5 className='mt-0 mb-16'>
          Are there any other considerations for the scheduled lock feature?
          </h5>
          <p className='text-sm mb-32'>
          Keep in mind that Doze mode is a mechanism designed to optimize battery life, and while it may temporarily impact scheduled tasks, it contributes to a more energy-efficient device. If you continue to experience issues with the scheduled lock feature, consider adjusting the settings or schedule to better align with your usage patterns and preferences.
          </p>
          <h5 className='mt-0 mb-16'>
          Why is a lock screen necessary for the proper functioning of the scheduled lock feature?
          </h5>
          <p className='text-sm mb-32'>
          The lock screen serves as a secure barrier to protect your device and its features. For the scheduled lock feature to work effectively, it relies on the lock screen to display notifications and activate the lock. Without a lock screen, the scheduled lock feature may not operate as intended, and notifications may not be presented on the lock screen.
          </p>
          <h5 className='mt-0 mb-16'>
          Do I need to have a lock screen set up on my phone for the scheduled lock feature in the KMO app to work properly?
          </h5>
          <p className='text-sm mb-32'>
          Yes, it is recommended to have a pin, pattern, or another form of lock screen security set up on your device for the scheduled lock feature in the KMO app to work seamlessly. Having a lock screen ensures that notifications from the scheduled lock feature are displayed correctly on the lock screen, and it allows the lock to be activated and function as intended.
          </p>
          <h5 className='mt-0 mb-16'>
          What type of lock screen should I set up for optimal performance of the scheduled lock feature?
          </h5>
          <p className='text-sm mb-32'>
          You can choose any secure lock screen option available on your device, such as a pin, pattern, password, or biometric authentication (fingerprint or facial recognition). The key is to have a form of security that ensures the privacy and integrity of your device while allowing the scheduled lock feature to work seamlessly.
          </p>
          <h5 className='mt-0 mb-16'>
          Can I still use the KMO app without setting up a lock screen on my device?
          </h5>
          <p className='text-sm mb-32'>
          While the KMO app may still function without a lock screen, it is highly recommended to set up a lock screen for an optimal experience. Having a lock screen enhances the security of your device, ensures that notifications are properly displayed, and allows the scheduled lock feature to operate seamlessly as intended.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HelpContent;
